module.exports = __webpack_public_path__ + "img/metalSale.d51fabe7.png";